import { useContext, useEffect, useMemo, useState } from 'react'
import { TableContext } from 'Context/Table'
import { SurveyViewContext } from '../Context'
import { LocationSelectionMapContext } from '../../../../Context/LocationSelectionModal'
import { useFormik } from 'formik'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { FormSurveyContext } from './Context'
import { useAuthStore } from 'Store/Auth'
import { useSaleOrderStore } from 'Store/SaleOrder'
import { useSurveyStore, INITIAL_STATE, BuildingInArea } from 'Store/Survey'
import { useAppStore } from 'Store/App'
import { shallow } from 'zustand/shallow'
import * as Yup from 'yup'
import Swal from 'sweetalert2'
import { isEqual, isObject } from 'lodash'
import { toast } from 'react-toastify'
import moment from 'moment'

const DIRECTION_INITIAL_STATE: BuildingInArea = {
  north: {
    characteristics: '',
    condition: '',
    distance: '',
    quantity: '',
  },
  south: {
    characteristics: '',
    condition: '',
    distance: '',
    quantity: '',
  },
  east: {
    characteristics: '',
    condition: '',
    distance: '',
    quantity: '',
  },
  west: {
    characteristics: '',
    condition: '',
    distance: '',
    quantity: '',
  },
}

// const FACOTORY_INITIAL_STATE = {
//   distance: '',
//   factory: '',
// }

const VALIDATION_SCHEMA_STEP1 = Yup.object().shape({})

const VALIDATION_SCHEMA_STEP2 = Yup.object().shape({})

const VALIDATION_SCHEMA_STEP3 = Yup.object().shape({
  jobStatus: Yup.string().nullable().required('กรุณาเลือกสถานะงาน'),
})

const ViewModel = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const isCreate = location.pathname.includes('create') && !!!id
  const isView = location.search.includes('view')

  const { setIsOpenImageUploaderModal } = useContext(SurveyViewContext)
  const {
    // currentSorting,
    updateLoading,
    updateError,
    updatePagination,
    updateDefaultSorting,
    resetState: resetTableState,
  } = useContext(TableContext)
  const setupTable = () => {
    updateDefaultSorting('id', true)
    updatePagination(true)
  }

  const {
    setOpen: setOpenSelectLocation,
    changeConfirm,
    setChangeConfirm,
    position,
    setPosition,
  } = useContext(LocationSelectionMapContext)

  const { currentStep, nextStep, prevStep, resetStep } = useContext(FormSurveyContext)
  const { saleOrders, saleOrder, getAllSaleOrder, getOneSaleOrder, clearStateSaleOrder } =
    useSaleOrderStore(
      state => ({
        saleOrders: state.data,
        saleOrder: state.selected,
        getAllSaleOrder: state.getAll,
        getOneSaleOrder: state.getOne,
        clearStateSaleOrder: state.clearState,
      }),
      shallow
    )
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)
  const { surveyLoading, selected, setSelected, downloadPdf, getOne, getImagePath } =
    useSurveyStore(
      state => ({
        surveyLoading: state.loading,
        selected: state.selected,
        downloadPdf: state.downloadPdf,
        setSelected: state.setSelected,
        getImagePath: state.getImagePath,
        getOne: state.getOne,
      }),
      shallow
    )
  const { create, update, newVersion } = useSurveyStore(
    state => ({
      create: state.create,
      update: state.edit,
      newVersion: state.newVersion,
    }),
    shallow
  )
  const setShowBackButton = useAppStore(state => state.setShowBackButton, shallow)

  const [hasFetchSurvey, setHasFetchSurvey] = useState(false)
  const [hasFetchSaleOrder, setHasFetchSaleOrder] = useState(false)
  const [hasPressedSubmit, setHasPressedSubmit] = useState(false)
  const [saleOrderItems, setSaleOrderItems] = useState<any[]>([])

  const [openStatusModal, setOpenStatusModal] = useState(false)
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)

  const data = selected?.survey ?? {}
  const latestVersion = selected?.latestRevision
  const versions = selected?.versions ?? []
  const userRoleId = profile?.roleId

  const handleOpenStatusModal = () => {
    formik.setFieldValue('jobStatus', data.jobStatus)
    setOpenStatusModal(true)
  }

  const handleCloseStatusModal = () => {
    setOpenStatusModal(false)
  }

  const handleOpenSelectLocation = () => {
    if (!isCreate) {
      setPosition({
        lat: data?.latitude,
        lng: data?.longitude,
      })
    } else {
      setPosition({
        lat: 13.7563,
        lng: 100.5018,
      })
    }

    setChangeConfirm(false)
    setOpenSelectLocation(true)
  }

  const handlePositionChange = () => {
    if (changeConfirm) {
      formik.setValues({
        ...formik.values,
        latitude: position.lat,
        longitude: position.lng,
      })

      setChangeConfirm(false)
    }
  }

  const clearStateSurvey = useSurveyStore(state => state.clearState)

  const saleOrderOptions = useMemo(
    () =>
      saleOrders.map(sale => ({
        label: sale.code,
        value: sale.id,
      })),
    [saleOrders]
  )

  const validationSchema = useMemo(() => {
    if (currentStep === 1) {
      return VALIDATION_SCHEMA_STEP1
    } else if (currentStep === 2) {
      return VALIDATION_SCHEMA_STEP2
    } else if (currentStep === 3) {
      return VALIDATION_SCHEMA_STEP3
    }
  }, [currentStep])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: INITIAL_STATE,
    validationSchema: validationSchema,
    validateOnBlur: true,
    onSubmit: values => onSubmit(values),
  })

  const handleInvalid = () => {
    if (hasPressedSubmit && !formik.isSubmitting) {
      if (Object.keys(formik.errors).length > 0) {
        console.log('formik.errors', formik.errors)

        const errorMessages = Object.entries(formik.errors).map(([key, value]) => {
          // Map field names to more user-friendly labels
          const fieldLabels: { [key: string]: string } = {
            jobStatus: 'สถานะงาน',
            // Add more field mappings as needed
          }

          const fieldLabel = fieldLabels[key] || key
          return `- ${fieldLabel}: ${value}`
        })

        Swal.fire({
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          html: `
            <div style="text-align: left;">
              <p>พบข้อผิดพลาดดังนี้:</p>
              <ul style="list-style-type: none; padding-left: 0;">
                ${errorMessages.map(msg => `<li>${msg}</li>`).join('')}
              </ul>
            </div>
          `,
          icon: 'error',
          confirmButtonText: 'ยืนยัน',
        })

        if (document.getElementsByClassName('is-invalid').length > 0) {
          document.getElementsByClassName('is-invalid')?.[0]?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        } else {
          document.getElementById('saleOrderPointer')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        }

        setTimeout(() => {
          setHasPressedSubmit(false)
        }, 300)
      }
    }
  }

  const handleOpenImageUploaderModal = () => {
    setIsOpenImageUploaderModal(true)
  }

  const fetchData = async () => {
    updateLoading(true)
    if (!isCreate && id) {
      // Fetch Survey
      const { success, data: responseData } = await getOne(parseInt(id))
      if (!success) {
        updateError(true)
        Swal.fire({
          title: 'ดึงข้อมูลไม่สำเร็จ',
          text: data,
          icon: 'error',
          confirmButtonText: 'ยืนยัน',
        }).then(() => {
          navigate(-1)
        })
        return
      } else {
        const surveyData = responseData?.survey ?? {}

        setHasFetchSurvey(true)

        let canConvertInstallationCategory = false
        let canConvertBuildingInArea = false
        // let canConvertFactory1 = false
        // let canConvertFactory2 = false
        // let canConvertFactory3 = false

        try {
          JSON.parse(surveyData?.installationCategory)
          canConvertInstallationCategory = true
        } catch (err: any) {
          canConvertInstallationCategory = false
        }

        try {
          JSON.parse(surveyData?.buildingInArea)
          canConvertBuildingInArea = true
        } catch (err: any) {
          canConvertBuildingInArea = false
        }

        // try {
        //   JSON.parse(surveyData?.distanceFromFactoryKm)
        //   canConvertFactory1 = true
        // } catch (err: any) {
        //   canConvertFactory1 = false
        // }

        // try {
        //   JSON.parse(surveyData?.distanceFromFactoryKm2)
        //   canConvertFactory2 = true
        // } catch (err: any) {
        //   canConvertFactory2 = false
        // }

        // try {
        //   JSON.parse(surveyData?.distanceFromFactoryKm3)
        //   canConvertFactory3 = true
        // } catch (err: any) {
        //   canConvertFactory3 = false
        // }

        formik.setValues({
          ...surveyData,
          sendQuotationDate: moment(surveyData?.sendQuotationDate),
          contractAgreedDate: moment(surveyData?.contractAgreedDate),
          rigToSiteDate: moment(surveyData?.rigToSiteDate),
          projectStartDate: moment(surveyData?.projectStartDate),
          contractStartDate: moment(surveyData?.contractStartDate),
          lastPiledDate: moment(surveyData?.lastPiledDate),
          // distanceFromFactoryKm:
          //   canConvertFactory1 && surveyData?.distanceFromFactoryKm
          //     ? JSON.parse(surveyData?.distanceFromFactoryKm)
          //     : '',
          // distanceFromFactoryKm2:
          //   canConvertFactory2 && surveyData?.distanceFromFactoryKm2
          //     ? JSON.parse(surveyData?.distanceFromFactoryKm2)
          //     : '',
          // distanceFromFactoryKm3:
          //   canConvertFactory3 && surveyData?.distanceFromFactoryKm3
          //     ? JSON.parse(surveyData?.distanceFromFactoryKm3)
          //     : '',
          adjacentPictureNorth: surveyData?.adjacentPictureNorth
            ? process.env.REACT_APP_BACKEND_API_URL +
              getImagePath(parseInt(id), surveyData?.adjacentPictureNorth)
            : '',
          adjacentPictureSouth: surveyData?.adjacentPictureSouth
            ? process.env.REACT_APP_BACKEND_API_URL +
              getImagePath(parseInt(id), surveyData?.adjacentPictureSouth)
            : '',
          adjacentPictureEast: surveyData?.adjacentPictureEast
            ? process.env.REACT_APP_BACKEND_API_URL +
              getImagePath(parseInt(id), surveyData?.adjacentPictureEast)
            : '',
          adjacentPictureWest: surveyData?.adjacentPictureWest
            ? process.env.REACT_APP_BACKEND_API_URL +
              getImagePath(parseInt(id), surveyData?.adjacentPictureWest)
            : '',
          installationCategory:
            canConvertInstallationCategory && surveyData?.installationCategory
              ? JSON.parse(surveyData?.installationCategory)
              : [],
          buildingInArea:
            canConvertBuildingInArea && surveyData?.buildingInArea
              ? JSON.parse(surveyData?.buildingInArea)
              : DIRECTION_INITIAL_STATE,
        })
      }
    }

    // Fetch All Sale Order
    const { success: successAllSaleOrder, data: dataAllSaleOrder } = await getAllSaleOrder()
    if (!successAllSaleOrder) {
      updateError(true)
      Swal.fire({
        title: 'ดึงข้อมูลไม่สำเร็จ',
        text: dataAllSaleOrder,
        icon: 'error',
        confirmButtonText: 'ยืนยัน',
      }).then(() => {
        navigate(-1)
      })
    }

    updateLoading(false)
  }

  const fetchSaleOrder = async () => {
    if (formik.values.saleOrderId) {
      const { success, data } = await getOneSaleOrder(formik.values.saleOrderId)
      if (!success) {
        Swal.fire({
          title: 'ดึงข้อมูลไม่สำเร็จ',
          text: data,
          icon: 'error',
          confirmButtonText: 'ยืนยัน',
        }).then(() => {
          navigate(-1)
        })
      } else {
        setHasFetchSaleOrder(true)
      }
    }
  }

  const handleDataSaleOrderItems = () => {
    if (isCreate) {
      if (hasFetchSaleOrder) {
        const items = saleOrder?.saleOrderItems ?? []
        const surveyItems = items.map((item: any) => {
          return {
            ...item,
            safeLoad: '',
            ps: '',
          }
        })

        setSaleOrderItems(surveyItems)
      }
    } else if (!isCreate && id) {
      if (hasFetchSaleOrder && hasFetchSurvey) {
        const items = saleOrder?.saleOrderItems ?? []
        const surveyItemsData = formik.values.surveySaleOrderItems ?? []

        const surveyItems = items.map((item: any) => {
          const surveyItem = surveyItemsData.find(
            surveyItem => surveyItem.saleOrderItemId === item.id
          )
          return {
            ...item,
            safeLoad: surveyItem?.safeLoad ?? '',
            ps: surveyItem?.ps ?? '',
          }
        })

        setSaleOrderItems(surveyItems)
      }
    }
  }

  const onChangeSaleOrderHeader = (saleOrderItemId: number) => {
    const saleOrder = saleOrders.find(sale => sale.id === saleOrderItemId)
    if (saleOrder) {
      formik.setFieldValue('saleOrderId', saleOrder.id)
      formik.setFieldValue('customerTitle', saleOrder.customerTitle)
      formik.setFieldValue('customerEmail', saleOrder.customerEmail)
      formik.setFieldValue('saleTitle', saleOrder.saleTitle)
      formik.setFieldValue('division', saleOrder.division)
    } else {
      formik.setFieldValue('saleOrderId', null)
    }
  }

  const onChangeSaleOrderItem = (saleOrderItemId: number, field: string, value: any) => {
    const saleOrderItemsData = saleOrderItems.map(item => {
      if (item.id === saleOrderItemId) {
        return {
          ...item,
          [field]: value,
        }
      }
      return item
    })

    setSaleOrderItems(saleOrderItemsData)
  }

  const onCheckInstallationCategory = (key: string, value: any) => {
    const installationCategory = formik.values.installationCategory
    const finded = installationCategory.find((item: any) => item.key === key)
    if (finded) {
      formik.setFieldValue(
        'installationCategory',
        installationCategory.filter((item: any) => item.key !== key)
      )
    } else {
      formik.setFieldValue('installationCategory', [...installationCategory, { key, quantity: '' }])
    }
  }

  const onChangeInstallationCategory = (key: string, value: any) => {
    const installationCategory = formik.values.installationCategory
    const finded = installationCategory.find((item: any) => item.key === key)
    if (finded) {
      formik.setFieldValue(
        'installationCategory',
        installationCategory.map((item: any) => {
          if (item.key === key) {
            return {
              ...item,
              quantity: value,
            }
          }
          return item
        })
      )
    }
  }

  const onChangeFactoryDistance = (name: string, key: string, value: any) => {
    formik.setFieldValue(name, value)
  }

  const normalizeStringNullToEmpty = (value: any) => {
    if (typeof value === 'string')
      return value === 'null' || value === 'undefined' || !value ? '' : value

    return value
  }

  const onSubmit = async (values: any) => {
    setHasPressedSubmit(false)
    setDisabledSubmitButton(true)
    const headerFields = [
      'saleOrderId',
      'customerTitle',
      'customerEmail',
      'saleTitle',
      'division',
      'address',
      'contactPersonFullName',
      'contactPersonPhone',
      'leadEngineerFullName',
      'leadEngineerPhone',
      'latitude',
      'longitude',
      'sendQuotationDate',
      'contractAgreedDate',
      'rigToSiteDate',
      'projectStartDate',
      'contractStartDate',
      'lastPiledDate',
      'onSiteAvailableTime',
      'pilingAvailableTime',
    ]

    if (currentStep === 1) {
      if (isView) {
        nextStep()
        setDisabledSubmitButton(false)
        return
      }

      // If current state is create, then create new survey
      if (isCreate) {
        const body: { [key: string]: any } = {
          // Head
          saleOrderId:
            values.saleOrderId &&
            values.saleOrderId !== null &&
            values.saleOrderId !== '' &&
            values.saleOrderId !== undefined &&
            values.saleOrderId !== 'null' &&
            values.saleOrderId !== 'undefined'
              ? values.saleOrderId
              : undefined,
          customerTitle: normalizeStringNullToEmpty(values.customerTitle),
          customerEmail: normalizeStringNullToEmpty(values.customerEmail),
          saleTitle: normalizeStringNullToEmpty(values.saleTitle),
          division: normalizeStringNullToEmpty(values.division),
          address: normalizeStringNullToEmpty(values.address),
          contactPersonFullName: normalizeStringNullToEmpty(values.contactPersonFullName),
          contactPersonPhone: normalizeStringNullToEmpty(values.contactPersonPhone),
          leadEngineerFullName: normalizeStringNullToEmpty(values.leadEngineerFullName),
          leadEngineerPhone: normalizeStringNullToEmpty(values.leadEngineerPhone),
          latitude: normalizeStringNullToEmpty(values.latitude ?? 0),
          longitude: normalizeStringNullToEmpty(values.longitude ?? 0),
          onSiteAvailableTime: normalizeStringNullToEmpty(values.onSiteAvailableTime),
          pilingAvailableTime: normalizeStringNullToEmpty(values.pilingAvailableTime),
          // Installation
          shippingOnly: normalizeStringNullToEmpty(values.shippingOnly),
          installationCategory: JSON.stringify(values.installationCategory),
          installationPlanner: values.installationCategory.find(
            (c: any) => c.key === 'PURE_DRIVE' || c.key === 'PREBORE_DRIVE'
          )
            ? values.installationPlanner
            : '',
          haveGroundworkPlan: values.haveGroundworkPlan,
          haveGroundworkPlanOther: values.haveGroundWorkPlanOther ?? '',
          haveLayoutPlan: values.haveLayoutPlan,
          haveLayoutPlanOther: values.haveLayoutPlanOther ?? '',
          useDavit: values.useDavit,
          davitSize: values.useDavit ? values.davitSize : '',
          davitHeightMeter: values.useDavit ? values.davitHeightMeter : '',
          davitQuantity: values.useDavit ? values.davitQuantity : '',
          usePD: values.usePD,
          pdSize: values.usePD ? values.pdSize : '',
          pdHeightMeter: values.usePD ? values.pdHeightMeter : '',
          pdQuantity: values.usePD ? values.pdQuantity : '',
          useLIP: values.useLIP,
          lipSize: values.useLIP ? values.lipSize : '',
          lipHeightMeter: values.useLIP ? values.lipHeightMeter : '',
          lipQuantity: values.useLIP ? values.lipQuantity : '',
          davitHeadSystem: normalizeStringNullToEmpty(values.davitHeadSystem),
          davitHeadSize: normalizeStringNullToEmpty(values.davitHeadSize),
          installationKits: normalizeStringNullToEmpty(values.installationKits),
          installationKitsSize: normalizeStringNullToEmpty(values.installationKitsSize),
          installationKitsLength: normalizeStringNullToEmpty(values.installationKitsLength),
          maxHeightEntranceMeter: normalizeStringNullToEmpty(values.maxHeightEntranceMeter),
          transportationByVehicle: normalizeStringNullToEmpty(values.transportationByVehicle),
          transportationAvailableTime: normalizeStringNullToEmpty(
            values.transportationAvailableTime
          ),
          distanceFromFactoryKm: normalizeStringNullToEmpty(values.distanceFromFactoryKm),
          distanceFromFactoryKm2: normalizeStringNullToEmpty(values.distanceFromFactoryKm2),
          distanceFromFactoryKm3: normalizeStringNullToEmpty(values.distanceFromFactoryKm3),
          craneToPole: normalizeStringNullToEmpty(values.craneToPole),
          craneToPoleOther: normalizeStringNullToEmpty(values.craneToPoleOther),
          haveBuildingInArea: normalizeStringNullToEmpty(values.haveBuildingInArea),
          adjacentPictureNorth:
            values.buildingInAreaEffectCondition === 'NO_SIDE_EFFECT'
              ? ''
              : values.adjacentPictureNorth ?? '',
          adjacentPictureSouth:
            values.buildingInAreaEffectCondition === 'NO_SIDE_EFFECT'
              ? ''
              : values.adjacentPictureSouth ?? '',
          adjacentPictureEast:
            values.buildingInAreaEffectCondition === 'NO_SIDE_EFFECT'
              ? ''
              : values.adjacentPictureEast ?? '',
          adjacentPictureWest:
            values.buildingInAreaEffectCondition === 'NO_SIDE_EFFECT'
              ? ''
              : values.adjacentPictureWest ?? '',
          buildingInAreaEffectCondition: normalizeStringNullToEmpty(
            values.buildingInAreaEffectCondition
          ),
          buildingInArea: JSON.stringify(values.buildingInArea),
          buildingInAreaResponsibility: normalizeStringNullToEmpty(
            values.buildingInAreaResponsibility
          ),
          riskOfDrilling: normalizeStringNullToEmpty(values.riskOfDrilling),
          riskOfDrillingPlan: normalizeStringNullToEmpty(values.riskOfDrillingPlan),
          sendQuotationDate: values.sendQuotationDate
            ? moment(values.sendQuotationDate).toISOString()
            : '',
          contractAgreedDate: values.contractAgreedDate
            ? moment(values.contractAgreedDate).toISOString()
            : '',
          rigToSiteDate: values.rigToSiteDate ? moment(values.rigToSiteDate).toISOString() : '',
          projectStartDate: values.projectStartDate
            ? moment(values.projectStartDate).toISOString()
            : '',
          contractStartDate: values.contractStartDate
            ? moment(values.contractStartDate).toISOString()
            : '',
          lastPiledDate: values.lastPiledDate ? moment(values.lastPiledDate).toISOString() : '',
        }

        create(body).then(({ success, data }) => {
          if (!success) {
            Swal.fire({
              title: 'บันทึกไม่สำเร็จ',
              text: data,
              icon: 'error',
              confirmButtonText: 'ยืนยัน',
            }).then(() => {
              setDisabledSubmitButton(false)
            })
          } else {
            navigate(`/survey/${data.id}`)

            nextStep()

            getOne(data.id).then(({ success: getOneSuccess }) => {
              if (getOneSuccess) {
                let canConvertInstallationCategory = false
                // let canConvertFactory1 = false
                // let canConvertFactory2 = false
                // let canConvertFactory3 = false

                try {
                  JSON.parse(data.installationCategory)
                  canConvertInstallationCategory = true
                } catch (err: any) {
                  canConvertInstallationCategory = false
                }

                // try {
                //   JSON.parse(data.distanceFromFactoryKm)
                //   canConvertFactory1 = true
                // } catch (err: any) {
                //   canConvertFactory1 = false
                // }

                // try {
                //   JSON.parse(data.distanceFromFactoryKm2)
                //   canConvertFactory2 = true
                // } catch (err: any) {
                //   canConvertFactory2 = false
                // }

                // try {
                //   JSON.parse(data.distanceFromFactoryKm3)
                //   canConvertFactory3 = true
                // } catch (err: any) {
                //   canConvertFactory3 = false
                // }

                formik.setValues({
                  ...data,
                  sendQuotationDate: moment(data.sendQuotationDate),
                  contractAgreedDate: moment(data.contractAgreedDate),
                  rigToSiteDate: moment(data.rigToSiteDate),
                  projectStartDate: moment(data.projectStartDate),
                  contractStartDate: moment(data.contractStartDate),
                  lastPiledDate: moment(data.lastPiledDate),
                  // distanceFromFactoryKm:
                  //   canConvertFactory1 && data.distanceFromFactoryKm
                  //     ? JSON.parse(data.distanceFromFactoryKm)
                  //     : '',
                  // distanceFromFactoryKm2:
                  //   canConvertFactory2 && data.distanceFromFactoryKm2
                  //     ? JSON.parse(data.distanceFromFactoryKm2)
                  //     : '',
                  // distanceFromFactoryKm3:
                  //   canConvertFactory3 && data.distanceFromFactoryKm3
                  //     ? JSON.parse(data.distanceFromFactoryKm3)
                  //     : '',
                  adjacentPictureNorth: data.adjacentPictureNorth
                    ? process.env.REACT_APP_BACKEND_API_URL +
                      getImagePath(parseInt(data.id), data.adjacentPictureNorth)
                    : '',
                  adjacentPictureSouth: data.adjacentPictureSouth
                    ? process.env.REACT_APP_BACKEND_API_URL +
                      getImagePath(parseInt(data.id), data.adjacentPictureSouth)
                    : '',
                  adjacentPictureEast: data.adjacentPictureEast
                    ? process.env.REACT_APP_BACKEND_API_URL +
                      getImagePath(parseInt(data.id), data.adjacentPictureEast)
                    : '',
                  adjacentPictureWest: data.adjacentPictureWest
                    ? process.env.REACT_APP_BACKEND_API_URL +
                      getImagePath(parseInt(data.id), data.adjacentPictureWest)
                    : '',
                  installationCategory: canConvertInstallationCategory
                    ? JSON.parse(data.installationCategory)
                    : [],
                  buildingInArea: isObject(data.buildingInArea)
                    ? JSON.parse(data.buildingInArea)
                    : DIRECTION_INITIAL_STATE,
                })
              }

              setDisabledSubmitButton(false)
              document.getElementById('survey-form-main-pointer')?.scrollIntoView({
                behavior: 'smooth',
              })
            })
          }
        })
      } else if (!isCreate && id && currentStep === 1) {
        if (isView) {
          nextStep()
          setDisabledSubmitButton(false)
          return
        }
        const editableFields = [
          'shippingOnly',
          'installationCategory',
          'installationPlanner',
          'haveGroundworkPlan',
          'haveGroundworkPlanOther',
          'haveLayoutPlan',
          'haveLayoutPlanOther',
          'davitSize',
          'davitHeightMeter',
          'davitQuantity',
          'useDavit',
          'pdSize',
          'pdHeightMeter',
          'pdQuantity',
          'usePD',
          'lipSize',
          'lipHeightMeter',
          'lipQuantity',
          'useLIP',
          'davitHeadSystem',
          'davitHeadSize',
          'installationKits',
          'installationKitSize',
          'installationKitsLength',
          'maxHeightEntranceMeter',
          'transportationByVehicle',
          'transportationAvailableTime',
          'distanceFromFactoryKm',
          'distanceFromFactoryKm2',
          'distanceFromFactoryKm3',
          'craneToPole',
          'craneToPoleOther',
          'haveBuildingInArea',
          'adjacentPictureNorth',
          'adjacentPictureSouth',
          'adjacentPictureEast',
          'adjacentPictureWest',
          'buildingInAreaEffectCondition',
          'buildingInArea',
          'buildingInAreaResponsibility',
          'riskOfDrilling',
          'riskOfDrillingPlan',
        ]

        const body: { [key: string]: any } = {}

        headerFields.forEach(field => {
          if (
            [
              'sendQuotationDate',
              'contractAgreedDate',
              'rigToSiteDate',
              'projectStartDate',
              'contractStartDate',
              'lastPiledDate',
            ].includes(field)
          ) {
            if (
              moment(values[field]).isValid() &&
              !moment(values[field]).isSame(moment(selected[field]))
            ) {
              body[field] = moment(values[field]).toISOString()
            }
          } else if (['latitude', 'longitude'].includes(field)) {
            if (
              Number(values[field]) !== Number(selected[field]) &&
              values[field] !== 0 &&
              values[field] !== null
            ) {
              body[field] = values[field]
            }
          } else if (values[field] === 'null') {
            body[field] = ''
          } else if (values[field] !== selected[field]) {
            if (field === 'saleOrderId') {
              if (
                values.saleOrderId &&
                values.saleOrderId !== null &&
                values.saleOrderId !== '' &&
                values.saleOrderId !== undefined &&
                values.saleOrderId !== 'null' &&
                values.saleOrderId !== 'undefined'
              ) {
                body[field] = values[field]
              }
            } else {
              body[field] = values[field]
            }
          }
        })
        editableFields.forEach(field => {
          if (
            [
              'adjacentPictureNorth',
              'adjacentPictureSouth',
              'adjacentPictureEast',
              'adjacentPictureWest',
            ].includes(field)
          ) {
            if (selected[field]) {
              if (values[field] && typeof values[field] !== 'string') {
                body[field] = values[field]
              } else if (!values[field]) {
                body[field] = null
              }
            } else if (values[field]) {
              body[field] = values[field]
            }
          } else if (field === 'buildingInArea') {
            const selectedBuildingInArea = isObject(data?.buildingInArea)
              ? data?.buildingInArea
              : JSON.parse(data?.buildingInArea)
            const buildingInAreaHasChanged = Object.keys(values.buildingInArea).some(
              direction =>
                !isEqual(values.buildingInArea[direction], selectedBuildingInArea?.[direction])
            )

            if (buildingInAreaHasChanged) {
              if (values.buildingInAreaEffectCondition === 'HAS_SIDE_EFFECT') {
                body[field] = JSON.stringify(values.buildingInArea)
              } else if (values.buildingInAreaEffectCondition === 'NO_SIDE_EFFECT') {
                body[field] = JSON.stringify(DIRECTION_INITIAL_STATE)
                body['adjacentPictureNorth'] = ''
                body['adjacentPictureSouth'] = ''
                body['adjacentPictureEast'] = ''
                body['adjacentPictureWest'] = ''
              }
            }
          } else if (field === 'installationCategory') {
            let canConvertSelectedInstallationCategory = false
            try {
              JSON.parse(data?.installationCategory)
              canConvertSelectedInstallationCategory = true
            } catch (err: any) {
              canConvertSelectedInstallationCategory = false
            }

            const selectedInstallationCategory = canConvertSelectedInstallationCategory
              ? JSON.parse(data?.installationCategory)
              : []
            let installationCategoryHasChanged = false
            if (selectedInstallationCategory.length !== values.installationCategory.length) {
              installationCategoryHasChanged = true
            } else if (selectedInstallationCategory.length === values.installationCategory.length) {
              installationCategoryHasChanged = selectedInstallationCategory.some((item: any) => {
                const finded = values.installationCategory.find(
                  (value: any) => value.key === item.key
                )
                if (finded) {
                  return finded.quantity !== item.quantity
                }
                return true
              })
            }

            if (installationCategoryHasChanged) {
              body[field] = JSON.stringify(values.installationCategory)
            }
          } else if (field === 'installationPlanner') {
            if (
              values.installationCategory.find(
                (c: any) => c.key === 'PURE_DRIVE' || c.key === 'PREBORE_DRIVE'
              )
            ) {
              body[field] = values.installationPlanner
            } else {
              body[field] = ''
            }
          } else if (values[field] !== selected[field]) {
            if (['usePD', 'useLIP', 'useDavit'].includes(field)) {
              if (values[field] === true) {
                body[field] = true
              } else {
                body[field] = false
                body[`${field.replace('use', '')}Size`] = ''
                body[`${field.replace('use', '')}HeightMeter`] = ''
                body[`${field.replace('use', '')}Quantity`] = ''
              }
            } else {
              body[field] = values[field]
            }
          }
        })

        if (Object.keys(body).length === 0) {
          nextStep()
          setDisabledSubmitButton(false)
          return
        }

        update(parseInt(id), body).then(({ success, data }) => {
          if (!success) {
            Swal.fire({
              title: 'บันทึกไม่สำเร็จ',
              text: data,
              icon: 'error',
              confirmButtonText: 'ยืนยัน',
            }).then(() => {
              setDisabledSubmitButton(false)
            })
          } else {
            nextStep()
            fetchData()
            fetchSaleOrder()
            setDisabledSubmitButton(false)
            document.getElementById('survey-form-main-pointer')?.scrollIntoView({
              behavior: 'smooth',
            })
          }
        })
      }
    } else if (currentStep === 2 && !isCreate && id) {
      if (isView) {
        nextStep()
        setDisabledSubmitButton(false)
        return
      }

      const editableFields = [
        'shippingOnly',
        'obstacleOnGround',
        'obstacleOnGroundRemark',
        'obstacleUnderGround',
        'obstacleUnderGroundRemark',
        'truckEntrance',
        'areaRai',
        'areaNgan',
        'areaSquareWa',
        'areaWidth',
        'areaLength',
        'areaFence',
        'entranceWidth',
        'entranceHeight',
        'entranceLength',
        'levelOfArea',
        'levelOfAreaHigherLevel',
        'levelOfAreaLowerLevel',
        'areaCondition',
        'areaConditionAddition',
        'roadEntranceWidth',
        'roadEntrance',
        'haveRoadInside',
        'haveRoadInsideRemark1',
        'haveRoadInsideRemark2',
        'haveRoadInsideRemark3',
        'haveProblem1',
        'haveProblem2',
        'haveProblem3',
        'polePointSurface',
        'polePointSurfaceAmount',
        'polePointSurfaceAmount2',
        'polePointSurfaceAmount3',
        'areaAdjustment',
        'electricityPreparation',
        'electricityHouse',
        'electricityLight',
        'electricityFCPTG',
        'houseForEmployee',
        'employeeTransportation',
        'employeeTransportationNote',
        'noteOther',
      ]

      const body: { [key: string]: any } = {}

      headerFields.forEach(field => {
        if (
          [
            'sendQuotationDate',
            'contractAgreedDate',
            'rigToSiteDate',
            'projectStartDate',
            'contractStartDate',
            'lastPiledDate',
          ].includes(field)
        ) {
          if (
            moment(values[field]).isValid() &&
            !moment(values[field]).isSame(moment(selected[field]))
          ) {
            body[field] = moment(values[field]).toISOString()
          }
        } else if (['latitude', 'longitude'].includes(field)) {
          if (
            Number(values[field]) !== Number(selected[field]) &&
            values[field] !== 0 &&
            values[field] !== null
          ) {
            body[field] = values[field]
          }
        } else if (values[field] !== selected[field]) {
          if (field === 'saleOrderId') {
            if (
              values.saleOrderId &&
              values.saleOrderId !== null &&
              values.saleOrderId !== '' &&
              values.saleOrderId !== undefined &&
              values.saleOrderId !== 'null' &&
              values.saleOrderId !== 'undefined'
            ) {
              body[field] = values[field]
            }
          } else {
            body[field] = values[field]
          }
        }
      })
      editableFields.forEach(field => {
        if (field === 'roadEntrance') {
          if (values[field] === 'dontHaveRoadEntrance') {
            body[field] = values[field]
            body['roadEntranceWidth'] = ''
          } else {
            body[field] = values[field]
          }
        } else if (values[field] !== selected[field]) {
          body[field] = values[field]
        }
      })

      if (Object.keys(body).length === 0) {
        nextStep()
        setDisabledSubmitButton(false)
        return
      }

      update(parseInt(id), body).then(({ success, data }) => {
        if (!success) {
          Swal.fire({
            title: 'บันทึกไม่สำเร็จ',
            text: data,
            icon: 'error',
            confirmButtonText: 'ยืนยัน',
          }).then(() => {
            setDisabledSubmitButton(false)
          })
        } else {
          nextStep()
          fetchData()
          fetchSaleOrder()
          setDisabledSubmitButton(false)
          document.getElementById('survey-form-main-pointer')?.scrollIntoView({
            behavior: 'smooth',
          })
        }
      })
    } else if (currentStep === 3 && !isCreate && id) {
      const editableFields = ['shippingOnly', 'noteRiskFinancial', 'safetyRequest', 'jobStatus']

      const body: { [key: string]: any } = {}

      headerFields.forEach(field => {
        if (
          [
            'sendQuotationDate',
            'contractAgreedDate',
            'rigToSiteDate',
            'projectStartDate',
            'contractStartDate',
            'lastPiledDate',
          ].includes(field)
        ) {
          if (
            moment(values[field]).isValid() &&
            !moment(values[field]).isSame(moment(selected[field]))
          ) {
            body[field] = moment(values[field]).toISOString()
          }
        } else if (['latitude', 'longitude'].includes(field)) {
          if (
            Number(values[field]) !== Number(selected[field]) &&
            values[field] !== 0 &&
            values[field] !== null
          ) {
            body[field] = values[field]
          }
        } else if (values[field] !== selected[field]) {
          if (field === 'saleOrderId') {
            if (
              values.saleOrderId &&
              values.saleOrderId !== null &&
              values.saleOrderId !== '' &&
              values.saleOrderId !== undefined &&
              values.saleOrderId !== 'null' &&
              values.saleOrderId !== 'undefined'
            ) {
              body[field] = values[field]
            }
          } else {
            body[field] = values[field]
          }
        }
      })
      editableFields.forEach(field => {
        if (values[field] !== selected[field]) {
          body[field] = values[field]
        }
      })

      if (Object.keys(body).length === 0) {
        Swal.fire({
          title: 'บันทึกสำเร็จ',
          text: 'บันทึกข้อมูลสำเร็จ',
          icon: 'success',
          confirmButtonText: 'ยืนยัน',
        }).then(() => {
          navigate('/survey')
          setDisabledSubmitButton(false)
        })
        return
      }

      update(parseInt(id), body).then(({ success, data }) => {
        if (!success) {
          Swal.fire({
            title: 'บันทึกไม่สำเร็จ',
            text: data,
            icon: 'error',
            confirmButtonText: 'ยืนยัน',
          }).then(() => {
            setDisabledSubmitButton(false)
          })
        } else {
          Swal.fire({
            title: 'บันทึกสำเร็จ',
            text: 'บันทึกข้อมูลสำเร็จ',
            icon: 'success',
            confirmButtonText: 'ยืนยัน',
          }).then(() => {
            navigate('/survey')
            setDisabledSubmitButton(false)
          })
        }
      })
    }
  }

  const onChangeStatus = (value: string) => {
    formik.setFieldValue('jobStatus', value)
  }

  const onSubmitStatus = async () => {
    if (!isCreate && id) {
      if (formik.values.jobStatus !== selected?.jobStatus) {
        const { success, data } = await update(parseInt(id), {
          jobStatus: formik.values.jobStatus,
        })
        if (!success) {
          toast.error(data)
        } else {
          setOpenStatusModal(false)
          toast.success('อัพเดทสถานะงานสำเร็จ')
          fetchData()
          fetchSaleOrder()
        }
      }
    }
  }

  const onDownloadPdf = async () => {
    if (id) {
      toast.info('กำลังดาวน์โหลดไฟล์ PDF กรุณารอสักครู่...')
      const { success, data } = await downloadPdf(parseInt(id))
      if (!success) {
        toast.error(data)
      } else {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `survey_${id}.pdf`)
        document.body.appendChild(link)
        link.click()
      }
    }
  }

  const onSaveHistory = async () => {
    const { isConfirmed } = await Swal.fire({
      title: 'คุณแน่ใจหรือไม่?',
      text: 'คุณต้องการบันทึกประวัติข้อมูลนี้หรือไม่ ข้อมูลเดิมจะถูกเก็บไว้เป็นประวัติ',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
      customClass: {
        confirmButton: 'btn btn-sm btn-primary',
        cancelButton: 'btn btn-sm btn-light',
      },
    })
    if (isConfirmed && id) {
      const { success, data } = await newVersion(parseInt(id))
      if (!success) {
        Swal.fire({
          icon: 'error',
          title: 'บันทึกไม่สำเร็จ',
          text: data,
        })
      } else {
        Swal.fire({
          icon: 'success',
          title: 'บันทึกสำเร็จ',
          text: `Survey ID: ${data.id}`,
        }).then(() => {
          navigate(`/survey/${data.id}`)
        })
      }
    }
  }

  // Initial Fetch for Edit
  useEffect(() => {
    setupTable()
    fetchData()
    setShowBackButton(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  // Fetch Sale Order to get Pile
  useEffect(() => {
    fetchSaleOrder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.saleOrderId])

  useEffect(() => {
    handleDataSaleOrderItems()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFetchSaleOrder, hasFetchSurvey, saleOrder, formik.values.surveySaleOrderItems, isCreate])

  // Clear State
  useEffect(() => {
    return () => {
      resetTableState()
      clearStateSurvey()
      clearStateSaleOrder()
      setSelected(INITIAL_STATE)
      resetStep()
      setShowBackButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Handle Position Change
  useEffect(() => {
    handlePositionChange()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeConfirm, position])

  useEffect(() => {
    handleInvalid()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPressedSubmit, formik.errors, formik.isSubmitting])

  return {
    isCreate,
    isView,
    userRoleId,
    // Step
    currentStep,
    nextStep,
    prevStep,
    disabledSubmitButton,
    // Options
    saleOrderOptions,
    // Form
    saleOrder,
    surveyLoading,
    survey: data,
    saleOrderItems: saleOrderItems,
    onDownloadPdf,
    onChangeSaleOrderItem,
    formik,
    onSubmit,
    handleOpenImageUploaderModal,
    onChangeSaleOrderHeader,
    onCheckInstallationCategory,
    onChangeInstallationCategory,
    onChangeFactoryDistance,
    // Job Status
    openStatusModal,
    handleOpenStatusModal,
    handleCloseStatusModal,
    onChangeStatus,
    onSubmitStatus,

    handleOpenSelectLocation,
    hasPressedSubmit,
    setHasPressedSubmit,

    latestVersion,
    versions,
    onSaveHistory,
  }
}

export default ViewModel
